module.exports = __webpack_public_path__ + "img/corsica.b4ea8f98.svg";